export const IAP_PRODUCTS = [
    'lite_monthly',
    'lite_yearly',
    'plus_monthly',
    'plus_yearly_1',
    'pro_monthly',
    'pro_yearly'
];
